import { render, staticRenderFns } from "./ConfigChangeover.vue?vue&type=template&id=afeff3be&scoped=true&"
import script from "./ConfigChangeover.vue?vue&type=script&lang=js&"
export * from "./ConfigChangeover.vue?vue&type=script&lang=js&"
import style0 from "./ConfigChangeover.vue?vue&type=style&index=0&id=afeff3be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afeff3be",
  null
  
)

export default component.exports